import { addDays, format, parseISO } from 'date-fns';
import { CalendarEventDatetime } from './calendar-event-datetime.model';

export function getCalendarDateOnly(value: CalendarEventDatetime): string {
  return value.localDateTimeString.split('T')[0];
}

export function getCalendarAllDayExclusiveEndDate(value: CalendarEventDatetime): string {
  const [date, time = ''] = value.localDateTimeString.split('T');
  const isAlreadyExclusiveEnd = time.startsWith('00:00');

  return isAlreadyExclusiveEnd ? date : format(addDays(parseISO(date), 1), 'yyyy-MM-dd');
}

export function getCalendarAllDayDateTimeString(date: string): string {
  return `${date}T00:00:00`;
}
